
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/device-privacy-policy-korea_ko",
      function () {
        return require("private-next-pages/device-privacy-policy-korea_ko/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/device-privacy-policy-korea_ko"])
      });
    }
  